import { Alert } from "@/ui/index";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";
import React from "react";

type UserHealthRestrictedProps = {
  className?: string;
};
export const UserHealthRestrictedAlert: React.FC<UserHealthRestrictedProps> = ({
  className = ""
}) => {
  const { isUserHealthRestricted } = useReserveForm();
  if (!isUserHealthRestricted) {
    return null;
  }

  return (
    <div className={className}>
      <Alert
        variant="tacticAlert"
        canDismiss={false}
        alertTitle={`Reservation's restricted`}
        alertMessage="Your organization's health &amp; safety policies prevent you from making a reservation. Please talk to a health admin."
        className="px-4 py-2"
      />
    </div>
  );
};
